import React from "react";
import "./scss/index.scss";
import * as animate from "animate.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import jwt_decode from "jwt-decode";
import setAuthToken from "./utils/setAuthToken";
import { setCurrentUser, logoutUser } from "./actions/authActions";
import { Provider } from "react-redux";
import store from "./store";

//components
import PrivateRoute from "./components/PrivateRoute";
import Dashboard from "./components/Dashboard";
import Account from "./components/Account";
import Login from "./components/Login";
import Search from "./components/Search";
import SearchCrypto from "./components/SearchCrypto";
import PageTransition from "./components/PageTransition";

if (localStorage.jwtToken) {
  const token = localStorage.jwtToken;
  setAuthToken(token);
  const decoded = jwt_decode(token);
  store.dispatch(setCurrentUser(decoded));
  const currentTime = Date.now() / 1000;
  if (decoded.exp < currentTime) {
    store.dispatch(logoutUser());
    window.location.href = "./login";
  }
}

function App() {
  return (
    <Provider store={store}>
      <PageTransition />
      <Router>
        <Route exact path="/" component={Login} />
        <Switch location={window.location}>
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
        </Switch>
        <Switch location={window.location}>
          <PrivateRoute exact path="/stocks" component={Search} />
        </Switch>
        <Switch location={window.location}>
          <PrivateRoute exact path="/cryptos" component={SearchCrypto} />
        </Switch>
        <Switch location={window.location}>
          <PrivateRoute exact path="/account" component={Account} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
